import { render, staticRenderFns } from "./TaxrollSearch.vue?vue&type=template&id=28956d63&"
import script from "./TaxrollSearch.vue?vue&type=script&lang=js&"
export * from "./TaxrollSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports